<spinner [showSpinner]="spinner$ | async"></spinner>
<router-outlet></router-outlet>